<template>
  <div class="container pb-10">
    <div class="flex items-center mb-10">
      <a href="/admin/forms/drafting-accreditation" class="text-gray-900 no-underline">
        <d-icon icon="arrow-left" size="1x" class="mr-3" />
        <span class="text-xl">Back To Listing Page</span>
      </a>
    </div>

    <h2>Applicant Details</h2>
    <div class="flex -mx-5 relative">
      <div class="w-1/2 px-5">
        <div class="mb-3">
          <p class="font-bold">
            First Name
          </p>
          <p v-text="computedApplicantInfo.firstName" />
        </div>
        <div class="mb-3">
          <p class="font-bold">
            Last Name
          </p>
          <p v-text="computedApplicantInfo.lastName" />
        </div>
        <div class="mb-3">
          <p class="font-bold">
            Email
          </p>
          <p v-text="computedApplicantInfo.email" />
        </div>
        <div class="mb-3">
          <p class="font-bold">
            Job Title
          </p>
          <p v-text="computedApplicantInfo.jobTitle" />
        </div>
        <div class="mb-3">
          <p class="font-bold">
            Phone #
          </p>
          <p v-text="computedApplicantInfo.phone" />
        </div>
        <div class="mb-3">
          <p class="font-bold">
            Fax #
          </p>
          <p v-text="computedApplicantInfo.fax" />
        </div>
      </div>

      <div class="w-1/2 px-5">
        <div class="mb-3">
          <p class="font-bold">
            Address Line 1
          </p>
          <p v-text="computedSubmissionDetails.revisedApplicantAddressLine1" />
        </div>
        <div class="mb-3">
          <p class="font-bold">
            Address Line 2
          </p>
          <p v-text="computedSubmissionDetails.revisedApplicantAddressLine2" />
        </div>
        <div class="mb-3">
          <p class="font-bold">
            City
          </p>
          <p v-text="computedSubmissionDetails.revisedApplicantCity" />
        </div>
        <div class="mb-3">
          <p class="font-bold">
            State
          </p>
          <p v-text="computedSubmissionDetails.revisedApplicantState" />
        </div>
        <div class="mb-3">
          <p class="font-bold">
            Zip/Postal
          </p>
          <p v-text="computedSubmissionDetails.revisedApplicantZip" />
        </div>
        <div class="mb-3">
          <p class="font-bold">
            Country
          </p>
          <p v-text="computedSubmissionDetails.revisedApplicantCountry" />
        </div>
      </div>
    </div>

    <hr>

    <h2>Additional Details</h2>
    <div class="flex -mx-5 relative">
      <div class="w-1/2 px-5">
        <div class="mb-3">
          <p class="font-bold">
            Drafting Experience
          </p>
          <p v-text="computedSubmissionDetails.revisedDraftingExperience" />
        </div>
        <div class="mb-3">
          <p class="font-bold">
            AWI Standards
          </p>
          <ul class="list-disc list-inside">
            <li v-for="standard in computedAwiStandards" :key="standard" v-text="standard" />
          </ul>
        </div>
        <div class="mb-3">
          <p class="font-bold">
            Referral Info
          </p>
          <p v-text="computedSubmissionDetails.revisedHowDidYouHearAboutProgram" />
        </div>
      </div>
    </div>

    <hr>

    <h2>Transaction Details</h2>
    <div>
      <div class="mb-3">
        <p class="font-bold">
          Amount
        </p>
        <p>${{ computedTransactionDetails.amount.toFixed(2) }}</p>
      </div>
      <div v-if="computedTransactionDetails.companyName" class="mb-3">
        <p class="font-bold">
          Company Name
        </p>
        <p v-text="computedTransactionDetails.companyName" />
      </div>
      <div v-if="computedTransactionDetails.billingAddress1" class="mb-3">
        <p class="font-bold">
          Billing Address 1
        </p>
        <p v-text="computedTransactionDetails.billingAddress1" />
      </div>
      <div v-if="computedTransactionDetails.billingAddress2" class="mb-3">
        <p class="font-bold">
          Billing Address 2
        </p>
        <p v-text="computedTransactionDetails.billingAddress2" />
      </div>
      <div v-if="computedTransactionDetails.billingCity" class="mb-3">
        <p class="font-bold">
          Billing City
        </p>
        <p v-text="computedTransactionDetails.billingCity" />
      </div>
      <div v-if="computedTransactionDetails.billingStateProvince" class="mb-3">
        <p class="font-bold">
          Billing State
        </p>
        <p v-text="computedTransactionDetails.billingStateProvince" />
      </div>
      <div v-if="computedTransactionDetails.billingZip" class="mb-3">
        <p class="font-bold">
          Billing Zip
        </p>
        <p v-text="computedTransactionDetails.billingZip" />
      </div>
      <div v-if="computedTransactionDetails.billingEmail" class="mb-3">
        <p class="font-bold">
          Billing Email
        </p>
        <p v-text="computedTransactionDetails.billingEmail" />
      </div>
      <div v-if="computedTransactionDetails.billingPhone" class="mb-3">
        <p class="font-bold">
          Billing Phone
        </p>
        <p v-text="computedTransactionDetails.billingPhone" />
      </div>
    </div>

    <hr>

    <h2>Professional Reference #1</h2>
    <div class="flex -mx-5 relative">
      <div class="w-1/2 px-5">
        <div class="mb-3">
          <p class="font-bold">
            First Name
          </p>
          <p v-text="computedReference1Info.firstName" />
        </div>
        <div class="mb-3">
          <p class="font-bold">
            Last Name
          </p>
          <p v-text="computedReference1Info.lastName" />
        </div>
        <div class="mb-3">
          <p class="font-bold">
            Email
          </p>
          <p v-text="computedReference1Info.email" />
        </div>
        <div class="mb-3">
          <p class="font-bold">
            Job Title
          </p>
          <p v-text="computedReference1Info.jobTitle" />
        </div>
        <div class="mb-3">
          <p class="font-bold">
            Phone #
          </p>
          <p v-text="computedReference1Info.phone" />
        </div>
        <div class="mb-3">
          <p class="font-bold">
            Fax #
          </p>
          <p v-text="computedReference1Info.fax" />
        </div>
      </div>

      <div class="w-1/2 px-5">
        <div class="mb-3">
          <p class="font-bold">
            Address Line 1
          </p>
          <p v-text="computedSubmissionDetails.revisedReference1AddressLine1" />
        </div>
        <div class="mb-3">
          <p class="font-bold">
            Address Line 2
          </p>
          <p v-text="computedSubmissionDetails.revisedReference1AddressLine2" />
        </div>
        <div class="mb-3">
          <p class="font-bold">
            City
          </p>
          <p v-text="computedSubmissionDetails.revisedReference1City" />
        </div>
        <div class="mb-3">
          <p class="font-bold">
            State
          </p>
          <p v-text="computedSubmissionDetails.revisedReference1StateProvince" />
        </div>
        <div class="mb-3">
          <p class="font-bold">
            Zip/Postal
          </p>
          <p v-text="computedSubmissionDetails.revisedReference1Zip" />
        </div>
        <div class="mb-3">
          <p class="font-bold">
            Country
          </p>
          <p v-text="computedSubmissionDetails.revisedReference1Country" />
        </div>
      </div>
    </div>

    <hr>

    <h2>Professional Reference #2</h2>
    <div class="flex -mx-5 relative">
      <div class="w-1/2 px-5">
        <div class="mb-3">
          <p class="font-bold">
            First Name
          </p>
          <p v-text="computedReference2Info.firstName" />
        </div>
        <div class="mb-3">
          <p class="font-bold">
            Last Name
          </p>
          <p v-text="computedReference2Info.lastName" />
        </div>
        <div class="mb-3">
          <p class="font-bold">
            Email
          </p>
          <p v-text="computedReference2Info.email" />
        </div>
        <div class="mb-3">
          <p class="font-bold">
            Job Title
          </p>
          <p v-text="computedReference2Info.jobTitle" />
        </div>
        <div class="mb-3">
          <p class="font-bold">
            Phone #
          </p>
          <p v-text="computedReference2Info.phone" />
        </div>
        <div class="mb-3">
          <p class="font-bold">
            Fax #
          </p>
          <p v-text="computedReference2Info.fax" />
        </div>
      </div>

      <div class="w-1/2 px-5">
        <div class="mb-3">
          <p class="font-bold">
            Address Line 1
          </p>
          <p v-text="computedSubmissionDetails.revisedReference2AddressLine1" />
        </div>
        <div class="mb-3">
          <p class="font-bold">
            Address Line 2
          </p>
          <p v-text="computedSubmissionDetails.revisedReference2AddressLine2" />
        </div>
        <div class="mb-3">
          <p class="font-bold">
            City
          </p>
          <p v-text="computedSubmissionDetails.revisedReference2City" />
        </div>
        <div class="mb-3">
          <p class="font-bold">
            State
          </p>
          <p v-text="computedSubmissionDetails.revisedReference2StateProvince" />
        </div>
        <div class="mb-3">
          <p class="font-bold">
            Zip/Postal
          </p>
          <p v-text="computedSubmissionDetails.revisedReference2Zip" />
        </div>
        <div class="mb-3">
          <p class="font-bold">
            Country
          </p>
          <p v-text="computedSubmissionDetails.revisedReference2Country" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      submissionDetails: {
        type: Object,
        default: () => ({}),
      },

      transactionDetails: {
        type: Object,
        default: () => ({}),
      },
    },

    computed: {
      computedSubmissionDetails: {
        get() {
          return this.submissionDetails;
        },
        set(value) {
          this.$emit('update:submissionDetails', value);
        },
      },

      computedTransactionDetails: {
        get() {
          return this.transactionDetails;
        },
        set(value) {
          this.$emit('update:transactionDetails', value);
        },
      },

      computedApplicantInfo() {
        return this.computedSubmissionDetails.revisedApplicant;
      },

      computedReference1Info() {
        return this.computedSubmissionDetails.revisedReference1;
      },

      computedReference2Info() {
        return this.computedSubmissionDetails.revisedReference2;
      },

      computedTransactionInfo() {
        return this.computedSubmissionDetails.transaction;
      },

      computedAwiStandards() {
        return JSON.parse(this.computedSubmissionDetails.revisedAWIStandards);
      },
    },
  };
</script>